module.exports = __webpack_public_path__ + "170bccfb4f0ca435054beb35007b13a6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.svg
// module id = 477
// module chunks = 1